import { computed } from 'vue'

export const HEADER_ID = 'guide'
export const DISCUSSION_ID = 'discussion'
const CHILD_HEADING_ID_PREFIX = 'heading'
const STARTING_INDEX = 1

export default function (guide) {
  const navHeaders = computed(() => {
    if (!guide.value?.description) return []

    // (<h\d>) matches <h2>, <h3>, etc...
    // (?:<[^<>]+>)* matches any number of other tags like <em> or <strong> but doesn't capture them
    // ([^<>]+?) matches the heading text
    const matches = guide.value.description.matchAll(
      /(<h\d>)(?:<[^<>]+>)*([^<>]+)/gi
    )
    const headings = []
    let id = STARTING_INDEX

    for (const match of matches) {
      const name = new DOMParser().parseFromString(match[2], 'text/html')
        .documentElement.innerText
      const level = parseInt(match[1][2])
      headings.push({ name: name || match[2], id: id++, level })
    }

    return headings
  })

  function generateChildHeadingId(index) {
    return `${CHILD_HEADING_ID_PREFIX}-${index}`
  }

  function insertHeadingIds(description) {
    let i = STARTING_INDEX
    return description.replace(
      /(<h\d)(>)/g,
      (_, m1) => `${m1} id="${generateChildHeadingId(i++)}">`
    )
  }

  return {
    generateChildHeadingId,
    insertHeadingIds,
    DISCUSSION_ID,
    navHeaders,
    HEADER_ID,
  }
}
